<template>
	<main class="edit">
			<div class="content">
				<div class="">
						<div class="card-header bg-1">
							<h4 v-if="user" class="mb-0 mt-1 ml-5">Editing user</h4>
							<h4 v-else class="mb-0 mt-1 ml-5">New user</h4>
						</div>
						<div class="card-body col-12 col-lg-6">
							<form action=";" class="cozy">
								<div class="form-group">
									<label for="email">Email address</label>
									<input
										v-model="email"
										type="email"
										class="form-control"
										id="email"
										aria-describedby="emailHelp"
										placeholder="Enter email">
									<small
										id="emailHelp"
										class="form-text text-muted">
										Will be used as username.
									</small>
								</div>
								<div class="form-group">
									<label for="name">Name</label>
									<input v-model="name"
										type="text" id="name"
										class="form-control"
										 placeholder="Name" />
								</div>
								<div class="form-group">
									<label for="name">Permission level</label>
									<select v-model="level.id"
										id="level"
										class="form-control">
										 <option value="null">Select</option>
										 <option v-for="l in levels" :value="l.id">{{l.name}}</option>
									 </select>
								</div>
								<div class="form-group">
										<label for="password">Password</label>
										<input v-model="password"
											type="text"
											id="password"
											class="form-control"
											placeholder="Password" />
								</div>
								<div class="input-group" v-if="user">
									<button v-on:click.prevent="update" class="btn btn-primary">
										Update User
									</button>
									<router-link
										:to="{ path: `/users`}"
										tag="button"
										class="btn btn-warning">
										Cancel
									</router-link>
									<button
										v-if="!removable"
										v-on:click.prevent="remove"
										class="btn btn-danger">
										Delete
									</button>
								</div>
								<div class="input-group" v-else>
									<button v-on:click.prevent="create" class="btn btn-accent">
										Create User
									</button>
									<router-link
										:to="{ path: `/users`}"
										tag="button"
										class="btn btn-warning">
										Cancel
									</router-link>
								</div>
							</form>
						</div>
					</div>
			</div>
		</main>
</template>

<script>
import Data from '../../main';

export default {
	name: 'UsersEdit',
	props: {
		editing: Boolean,
	},
	data() {
		return {
			selfdata: Data,
			user: this.editing,
			name: null,
			email: null,
			password: null,
			removable: true,
			level: {'id':'', 'name':''},
			levels: []
		};
	},


	mounted() {
		this.getLevels();

		if (this.$route.params.id == undefined) {
			return;
		}

		this.user = this.$route.params.id;

		if(Data.user.id != parseInt(this.user))
		 	this.removable = false;

		this.$Progress.start();

		this.$axios
			.get('/user/' + this.user)
			.then((response) => {
				this.name = response.data.name;
				this.email = response.data.email;
				this.level = response.data.level ? response.data.level : {id: 0};
			})
			.catch((error) => {
				console.log(error);
			})
			.finally(()=>{
				this.$Progress.finish();
			});

	},
	methods: {
		getLevels(){
			const p = this.$Progress;
			const a = this.$axios;
			const that = this;

			p.start();
			a.get(`/user/levels`)
				.then((response) => {
					this.levels = response.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					p.finish();
				});
		},
		update: function() {
			this.$Progress.start();

			let data = {
				name: this.name,
				email: this.email,
				level: this.level.id
			};

			if( this.password ) data.password = this.password;

			this.$axios
				.put('/user/' + this.user, data)
				.then((response) => {
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'User updated.',
						type: 'success',
					});
					this.$router.push({path: '/users'});
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},
		create: function() {
			this.$Progress.start();
			this.$axios
				.post('/user', {
					name: this.name,
					email: this.email,
					password: this.password,
					level: this.level.id
				})
				.then((response) => {
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'User added.',
						type: 'success',
					});
					this.$router.push({path: '/users'});
				})
				.catch((error) => {
					console.log(error);
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},
		remove: function() {
			if(!confirm("Remove user?")) return;

			this.$Progress.start();
			this.$axios
				.delete('/user/' + this.user)
				.then((response) => {
					this.$notify({
						group: 'main',
						title: 'Done.',
						text: 'User removed.',
						type: 'success',
					});
					this.$router.push({path: '/users'});
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},

	},
};
</script>
